import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { BaseTextAreaProps } from "./BaseTextArea.types";

const BaseTextArea = forwardRef<
  HTMLTextAreaElement,
  PropsWithChildren<BaseTextAreaProps>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "h-full min-h-20 w-full resize-none rounded-md border border-neutral-500 text-sm text-neutral-900",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});

BaseTextArea.displayName = "BaseTextArea";

export default BaseTextArea;
